<template lang="html">
  <material-card
    :title="title"
    :text="text"
    dark
    color="busie">
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-text-field
          type="number"
          label="Minimum Seats"
          v-model="payload.minSeats"/>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          type="number"
          label="Maximum Seats"
          v-model="payload.maxSeats"/>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <cancel-btn @click="resetAndClose"/>
      <save-btn @click="save"/>
    </v-card-actions>
  </material-card>
</template>

<script>
import MaterialCard from '@/components/material/Card'
import SaveButton from './SaveButton'
import CancelButton from './CancelButton'

export default {
  components: {
    'material-card': MaterialCard,
    'save-btn': SaveButton,
    'cancel-btn': CancelButton
  },
  props: {
    bus: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      text: 'Update seat range for this bus.',
      friendlyNames: {
        'motorcoach': 'Motor Coach',
        'minibus': 'Mini Bus',
        'executivecoach': 'Executive Coach',
        'partybus': 'Party Bus',
        'schoolbus': 'School Bus',
        'entertainercoach': 'Entertainer Coach',
        'trolley': 'Trolley',
        'van': 'Van'
      },
      payload: {}
    }
  },
  computed: {
    title () {
      return 'Trip Seating for ' + this.friendlyBusType
    },
    friendlyBusType () {
      return this.friendlyNames[this.bus.type]
    }
  },
  mounted () {
    this.createFreshPayload()
  },
  methods: {
    save () {
      this.$emit('save', this.payload)
      this.$emit('close')
    },
    resetAndClose () {
      this.createFreshPayload()
      this.$emit('close')
    },
    createFreshPayload () {
      this.payload = {
        id: this.bus.id,
        type: this.bus.type,
        minSeats: this.bus.minSeats,
        maxSeats: this.bus.maxSeats
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
